<template>
  <Modal
    v-model="_value"
    width="600"
    title="确认收款"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">

    <Form v-if="installOrderList.length > 0" ref="loginForm" :model="installOrderList" :label-width="90">
      <div v-for="item in installOrderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.tempVehicleInfo != null ? item.tempVehicleInfo.registrationNum : item.vehicleInfo.registrationNum}}</label>
          <label style="display: inline-block;">下单时间：{{new Date(item.createDatetime).Format('yyyy年MM月dd日')}}</label>
          <br>
          <label style="display: inline-block; width: 100px;">金额：{{item.totalAmount}}</label>
          <label style="display: inline-block;">到费日期：{{new Date(item.serviceDatetime).Format('yyyy年MM月dd日')}}</label>
        </FormItem>
      </div>
      <div v-if="installOrder.step != null">
        <FormItem prop="state" label="收款结果">
          <Select style="width: 100px;" v-model="installOrderListstepstate">
            <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="result" label="不通过原因" v-if="installOrderListstepstate == 3">
          <Input style="display: inline-block; width: 400px;" type="textarea" v-model="installOrderListstepresult"
                 placeholder="不通过原因">
          </Input>
        </FormItem>
        <FormItem prop="receptDatetime" label="收款时间" v-if="installOrderListstepstate == 2">
          <DatePicker type="date" v-model="installOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
      </div>
      <div v-else>
        <FormItem prop="receptDatetime" label="收款时间">
          <DatePicker type="date" v-model="installOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
      </div>
    </Form>

    <Form v-else ref="loginForm" :model="installOrder" :label-width="90">
      <FormItem prop="registrationNum" label="车牌号">
        <label style="display: inline-block; width: 100px;">{{installOrder.tempVehicleInfo != null ? installOrder.tempVehicleInfo.registrationNum : installOrder.vehicleInfo.registrationNum}}</label>
        <label style="display: inline-block;">下单时间：{{new Date(installOrder.createDatetime).Format('yyyy年MM月dd日')}}</label>
        <br>
        <label style="display: inline-block; width: 100px;">金额：{{installOrder.totalAmount}}</label>
        <label style="display: inline-block;">到费日期：{{new Date(installOrder.serviceDatetime).Format('yyyy年MM月dd日')}}</label>
      </FormItem>
      <div v-if="installOrder.step != null">
      <FormItem prop="state" label="收款结果">
        <Select style="width: 100px;" v-model="installOrder.step.state">
          <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result" label="不通过原因" v-if="installOrder.step.state == 3">
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="installOrder.step.result"
               placeholder="不通过原因">
        </Input>
      </FormItem>
      <FormItem prop="receptDatetime" label="收款时间" v-if="installOrder.step.state == 2">
        <DatePicker type="date" v-model="installOrder.receptDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      </div>
      <div v-else>
        <FormItem prop="receptDatetime" label="收款时间">
          <DatePicker type="date" v-model="installOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
      </div>
    </Form>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'confirmreceptmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      installOrder: {
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        businessType: 1,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        billType: 1,
        vehicleInfoGroupId: null,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        vehicleInfoId: null,
        isfree: 1,
        reInstall: false,
        tempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          salesChannelId: null,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        bookingDatetime: new Date(new Date().setDate(new Date().getDate() + 1)),
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null,
        newPositioningDeviceFittingsModel: {

        }
      },

      installOrderList: [],
      installOrderIds: [],
      installOrderListstepstate: null,
      installOrderListstepresult: null,

      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ConfirmRecept',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      if (this.installOrderList != null && this.installOrderList.length > 0) {
        store.dispatch('InstallOrderServ_BatchConfirmRecept', {
          params:
              {
                installOrderList: this.installOrderIds,
                state: this.installOrderListstepstate,
                result: this.installOrderListstepresult,
                receptDatetime: new Date(this.installOrder.receptDatetime).Format('yyyy-MM-dd hh:mm:ss')
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认收款成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '确认收款',
          content: '<p>注意：确认收款后不能恢复未收款状态</p>',
          onOk: () => {
            store.dispatch('InstallOrderServ_ConfirmRecept', { params: this.installOrder }).then(() => {
              this.$Message.success('确认收款成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.installOrder.id = null
        this.installOrder.receptDatetime = null

        this.installOrderList = this._listValue
        if (this.installOrderList != null && this.installOrderList.length > 0) {
          this.installOrderList.forEach(item => {
            this.installOrderIds.push(item.id)
          })
          this.installOrder.receptDatetime = new Date()
          this.installOrderListstepstate = 2
        } else {
          this.installOrderIds = []

          let installOrderId = this._initValue
          if (installOrderId) {
            store.dispatch('InstallOrderServ_GetDetail', {
              params: { id: installOrderId }
            }).then(() => {
              this.installOrder = store.getters.get_InstallOrder_GetDetailResult
              this.installOrder.receptDatetime = new Date()
              if (this.installOrder.step) {
                this.installOrder.step.state = 2
              }
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
